module.exports = __webpack_public_path__ + "img/nuren-logo.ea60bcff.png";